<template>
<el-dialog title="选择零件" width="80%" :visible.sync="viewData.visible" :close-on-click-modal="false" append-to-body>
    <div class="content-body tenant-settings">
        <!-- <div class="" style="background: red ;display: none"> -->
        <div class="">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
                <el-form-item label="物料编码:">
                    <el-input size="small" v-model="dataForm.materialCode" placeholder="物料编码" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="物料中文描述:">
                    <el-input size="small" v-model="dataForm.materialName" placeholder="物料中文描述" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="物料组:">
                    <el-input size="small" v-model="dataForm.materialGroup" placeholder="物料组" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item label="物料组描述:">
                    <el-input size="small" v-model="dataForm.materialGroupName" placeholder="物料组描述" clearable @blur="getDataList"></el-input>
                </el-form-item>
                <el-form-item class="fr">
                    <el-button size="small" @click="getDataList()" icon="el-icon-search">
                        查询
                    </el-button>
                    <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button> -->
                    <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
                </el-form-item>
            </el-form>
            <div v-loading="dataListLoading">
                <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%; margin-bottom:15px;">
                    <el-table-column label="选择" type="selection" width="55">
                        <template slot-scope="scope">
                            <input type="checkbox" v-model="selectPartList" :value="scope.row" />
                        </template>
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="factoryCode" header-align="center" align="left" label="工厂">
                        <template slot-scope="scope">
                            {{getFactoryName(scope.row.factoryCode)}}
                        </template>
                        <!-- <span v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                </span> -->
                    </el-table-column>
                    <el-table-column prop="materialCode" header-align="center" align="left" label="物料编码">
                    </el-table-column>
                    <el-table-column prop="materialName" header-align="center" align="left" label="物料中文描述">
                    </el-table-column>
                    <el-table-column prop="materialGroup" header-align="center" align="left" label="物料组">
                    </el-table-column>
                    <el-table-column prop="materialGroupName" header-align="center" align="left" label="物料组描述">
                    </el-table-column>
                    <el-table-column prop="basicUnit" header-align="center" align="left" label="基本计量单位" width="100">
                        <template slot-scope="scope">
                            {{getUnitName(scope.row.basicUnit)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="auxiliaryUnit" header-align="center" align="left" label="辅助单位" width="80">
                        <template slot-scope="scope">
                            {{getUnitName(scope.row.auxiliaryUnit)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="numerator" header-align="center" align="left" label="转换分子" width="80">
                    </el-table-column>
                    <el-table-column prop="denominator" header-align="center" align="left" label="转换分母" width="80">
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align:right" class="mt15 mb15">
                </el-pagination>
            </div>
        </div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <!-- 询价中 -->
        <el-button size="small" type="primary" plain @click="confirm()" :loading="btnloading">
            确认
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    partList,
    // list
} from '@/controller/mdata'
import {
    createPartList
    // list
} from '@/controller/tech'
import {
    DIALOG_CLOSED_TYPE
} from "@/utils/const";
import {
    getFactoryList,
    getUnitList
} from '@/controller/systemData'
import PartAddOrUpdate from './part-add-or-update'
import {
    setLoading
} from "@/utils/index";
export default {
    props: {
        partFormData: Object,
    },
    data() {
        return {
            btnloading: false,
            viewData: {
                visible: false,
                width: ''
            },
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                id: 0,
                factoryCode: '',
                materialCode: '',
                basicUnit: '',
                auxiliaryUnit: '',
                numerator: '',
                denominator: '',
                materialName: '',
                materialGroup: '',
                materialGroupName: '',
                technicalId: '',
            },
            dataList: [],
            tenantList: [],
            partList:[],
            factoryList: [],
            selectPartList: [],
            unitList: [],
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            partAddOrUpdateVisible: false,
            supplyStatus: '1',
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        PartAddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        open(materialCodes,partList) {
            this.viewData.visible = true
            this.loading = false
            this.pageSize = 10
            this.pageIndex = 1
            this.selectPartList=[]
            this.partList = partList
            this.getDataList(materialCodes)
        },
        onClosed(params) {
            console.log(params)
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            this.onClosed({
                option,
                sender: this,
                data: "OK",
            });
            this.viewData.visible = false;
        },
        confirm() {
            this.btnloading = true
            setLoading()
            // 保存appartmentList零件 调用批量添加
            console.log(this.selectPartList)
            // debugger
            console.log(this.partFormData)
            if (!this.partFormData) return
            // console.log(this.basicFormData.id)
            const params = this.selectPartList.map(v => {
                return {
                    technicalId: this.partFormData.id,
                    partCode: v.materialCode,
                    partName: v.materialName,
                    unit: v.basicUnit,
                    supplyStatus: this.supplyStatus,
                }
            })
            for (let index1 = 0; index1 < this.selectPartList.length; index1++) {
                const element1 = this.selectPartList[index1];
                for (let index2 = 0; index2 < this.partList.length; index2++) {
                    const element2 = this.partList[index2];
                    if(element1.materialCode == element2.partCode){
                        this.$message.error("零件已经存在，请重新选择");
                        this.btnloading = false
                        return
                    }
                }
            }
            console.log(params)
            createPartList(params).then((data) => {
                if (data && data.code === "00") {
                    this.result = "OK"
                    this.$message({
                        message: "零件添加成功",
                        type: "success",
                    });
                    this.close(DIALOG_CLOSED_TYPE.CONFIRM);
                    this.btnloading = false
                } else {
                    this.$message.error(data.msg);
                }

            }).catch(e => {
                console.error(e)
            }).finally(() => {
                this.btnloading = false
            })
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getFactoryList()
            this.getUnitList()
            partList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'factoryCode': this.dataForm.factoryCode,
                'materialCode': this.dataForm.materialCode,
                'basicUnit': this.dataForm.basicUnit,
                'auxiliaryUnit': this.dataForm.auxiliaryUnit,
                'numerator': this.dataForm.numerator,
                'denominator': this.dataForm.denominator,
                'materialName': this.dataForm.materialName,
                'materialGroup': this.dataForm.materialGroup,
                'materialGroupName': this.dataForm.materialGroupName,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                    console.log('this.dataList', this.dataList)
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        getUnitList() {
            getUnitList({
                code: '',
                name: ''
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            })
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
